import { render, staticRenderFns } from "./VArrowRight.vue?vue&type=template&id=7bae48f6&"
import script from "./VArrowRight.vue?vue&type=script&lang=js&"
export * from "./VArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports